
<template>
    <div class="ion-page">
       
        <ion-header class="rp-mobile">
            <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    <ion-menu-button></ion-menu-button>
                    <ion-grid class="title-wrapper ion-no-padding">
                        <ion-row>
                            <ion-col size-md="8">
                                <ion-title>CARTER STATION MAP</ion-title>
                            </ion-col>
                            <ion-col size-md="4"  class="ion-no-padding ion-text-right">
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding google-map-wrapper">
            <CarterGoogleMap :key="mapCompKey" v-if="viewChange" />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { IonHeader,IonToolbar, IonContent ,IonButtons,IonMenuButton,IonGrid,IonRow,IonCol, IonTitle } from "@ionic/vue";
// import reservationListView from "@/views/customer/reservationListView.vue";
import CarterGoogleMap from "./CarterGoogleMap.vue";

export default defineComponent ({
  name: "carterReservation",
    name: '',
    components: {
      IonHeader,
      IonToolbar,
      IonContent,
      IonButtons,
      IonMenuButton,
      IonGrid,
      IonRow,
      IonCol,
      IonTitle,
    //   reservationListView,
      CarterGoogleMap
    },
    data() {
        return {
          currentLoc: {},
          locationAdd: "",
          mapCompKey: 0,
          viewChange: true,
          amountDetails: {
            totalBalance: "",
            clearBalance: ""
          }
        }
    },
    mounted() {
      localStorage.removeItem("slotDetails");
      localStorage.removeItem("editReservationDetails");
      localStorage.removeItem("editReservationPage");
      localStorage.removeItem("teleUrl");
      localStorage.removeItem("selectedMarker");
      localStorage.removeItem("opensAt");
      localStorage.removeItem("closesAt");
      localStorage.removeItem("selectedChargerValue");
      localStorage.removeItem("amountDetails");
      localStorage.removeItem("chargeNow");
      localStorage.removeItem("qrCodeValue");
      localStorage.removeItem("portId");
      localStorage.removeItem("duration");
      localStorage.removeItem("outputNumber");
      localStorage.removeItem("stationList");
    //   new WalletService().summaryOfUser(new LocalStorage().user).then(data => {
    //     this.amountDetails = {
    //       totalBalance: data.totalBalance.toFixed(2),
    //       clearBalance: data.clearBalance.toFixed(2)
    //     };
    //     localStorage.setItem("amountDetails", JSON.stringify(this.amountDetails));
    //   });
    },
    methods: {
    listViewChange() {
      this.viewChange = false;
    },
    mapViewChange() {
      this.viewChange = true;
    },
    filterPage() {
      this.$router.push("/customer/reservationFilter");
    }
  }
})
</script>



<style scoped>
  .google-map-wrapper {
    position: absolute;
    background: #f4f5f9 0% 0% no-repeat padding-box;
    top: 54px;
  }
  @media (max-width: 767px) {
    .google-map-wrapper {
      top: 64px;
      /* Status bar height on iOS 11.0 */
      top: calc(constant(safe-area-inset-top) + 65px);
      /* Status bar height on iOS 11+ */
      top: calc(env(safe-area-inset-top) + 65px);

      padding-bottom: 0px;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      max-width: 100%;
    }
  }
  @media (min-width: 300px) and (max-width: 358px) {
    .title-wrapper .price-tag:first-child {
      margin-top: 5px;
    }
    .title-wrapper .price-tag p:first-child,
    .title-wrapper .price-tag p:last-child {
      font-size: 12px !important;
    }
  }
  .filter-option-wrapper {
    z-index: 99;
  }

  .res-content-wrapper.mapView {
    position: absolute;
    width: 100%;
    top: 0;
    padding: 16px;
  }

  .filter-option img:first-child {
    width: 23px !important;
    height: 23px !important;
    top: 4px;
    position: relative;
  }

  .res-content-wrapper.listView .loc-search {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #d6d6d6;
    background: #f4f5f9;
  }

  .res-content-wrapper.listView {
    background: #f4f5f9;
  }

  .res-content-wrapper .loc-search input {
    height: 52px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    border-radius: 12px;
    opacity: 1;
    width: 100%;
    padding: 12px;
    padding-left: 98px !important;
    font-size: 14px;
    text-align: left;
    padding-left: 24px;
    font-family: "Roboto";
    letter-spacing: 0;
    color: #9e9d9d;
  }

  .res-content-wrapper .loc-search img {
    width: 18px;
    height: 18px;
    opacity: 1;
    cursor: pointer;
  }

  .loc-wrpaper span {
    height: 17px;
    text-align: left;
    font-size: 14px;
    position: absolute;
    font-family: "Roboto";
    letter-spacing: 0;
    top: 18px;
    padding-left: 18px;
    color: #404040;
    opacity: 1;
  }

  .filter-option img:first-child {
    width: 20px !important;
    height: 15px !important;
    top: 4px;
    position: relative;
  }

  .filter-option img:last-child {
    width: 16px !important;
    height: 17px !important;
    top: 5px;
    left: 12px;
    position: relative;
  }

  .loc-wrpaper img,
  .loc-wrpaper span {
    z-index: 99;
  }

  .loc-wrpaper {
    position: relative;
  }

  .loc-wrpaper img {
    position: absolute;
    right: 12px;
    top: 17px;
    cursor: pointer;
  }

  @media (min-width: 768px) {
    .title-wrapper .ion-no-padding.mobile-view-style {
      text-align: right;
    }
  }

  .filter-option img.listViewIcon {
    width: 23px !important;
    height: 23px !important;
    top: 0px;
    position: relative;
  }

  .res-content-wrapper.listView .filter-option img:last-child {
    top: 0px;
  }

  @media (max-width: 768px) {
    .header-toolbar {
      --background: #21b24b;
    }
    .res-content-wrapper.listView .loc-search {
      background: #fff;
    }

    .header-toolbar ion-menu-button {
      --color: #fff;
      margin-right: 13px;
    }

    .filter-option img:first-child {
      margin-right: 8px;
    }

    .res-content-wrapper .loc-search input {
      padding-left: 129px !important;
      text-overflow: ellipsis;
      padding-right: 56px;
    }

    .rp-mobile .filter-option {
      border: none;
      width: 80px;
      padding-left: 12px;
    }

    .title-wrapper .mobile-view-style {
      padding: 1px 0px;
    }

    .filter-option img.listViewIcon {
      width: 23px !important;
      height: 23px !important;
      top: 0px;
      position: relative;
    }

    .title-wrapper .price-tag {
      margin-right: 0px !important;
    }

    .title-wrapper .price-tag:first-child {
      margin-right: 12px !important;
    }

    .title-wrapper .price-tag p {
      color: #fff !important;
    }

    .filter-option.optionlistView img:last-child {
      top: 0px;
    }

    .res-content-wrapper.mapView {
      padding: 0px;
      padding-top: 16px;
    }
  }

  .title-wrapper .price-tag {
    display: inline-block;
    margin-right: 20px;
    padding-top: 5px;
    padding-bottom: 7px;
  }

  .title-wrapper .price-tag p:first-child,
  .title-wrapper .price-tag p:last-child,
  .title-wrapper ion-title {
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
  }

  .title-wrapper ion-title {
    font-weight: 500;
    padding-top: 0px;
    /* padding-top: 15px; */
    margin-left: 45px;
    position: static;
    
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
    /* top: 6px; */
  }

  .title-wrapper .price-tag p:last-child {
    font-family: "Roboto Medium";
  }
  .filter-option {
    width: 92px;
    height: 52px;
    background: #21b24b 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    border-radius: 12px;
    opacity: 1;
    padding: 12px 18px;
  }

  @media (max-width: 768px) {
    .mobile-header-toolbar {
      --background: #21b24b;
    }
    .mobile-header-toolbar {
      height: 60px;
      padding-top: 0px;
    }
    .mobile-header-toolbar ion-title {
      color: #ffffff;
    }
    .mobile-header-toolbar ion-buttons {
      color: #ffffff;
      --background: #ffffff;
    }
    .mobile-header-toolbar ion-menu-button {
      color: #ffffff;
      margin-right: 13px;
    }

    .mobile-header-toolbar .price-tag:first-child {
      margin-top: 5px;
    }
    .mobile-header-toolbar .price-tag p:first-child,
    .mobile-header-toolbar .price-tag p:last-child {
      font-family: "Roboto Medium";
      font-size: 12px !important;
    }
    .mobile-header-toolbar .price-tag p {
      color: #fff !important;
    }
    .mobile-header-toolbar .price-tag {
      display: inline-block;
      margin-right: 20px;
      padding-top: 5px;
      padding-bottom: 7px;
    }
    .mobile-header-toolbar .filter-option {
      top: 0px;
    }
  }
</style>